<template>
  <div class="pageBox">
    <van-steps :active="active" @click-step="toStep" active-icon="success" active-color="#38f" style="font-weight: bold">
      <van-step>合作</van-step>
      <van-step>基础信息</van-step>
      <van-step>签约信息</van-step>
      <van-step>合同项目</van-step>
      <van-step>附件</van-step>
      <van-step>收款约定</van-step>
    </van-steps>
    <!-- @click="isFixed?'':showCascader('dept')"  -->
    <!-- @click="isFixed?'':form.deptId?showPicker('userName'):''" -->
    <!-- @click="isFixed?'':form.userId?showPicker('boId'):''" -->
    <van-form ref="cooperationForm" validate-trigger="onSubmit" v-if="active == 0" class="contractForm">
      <van-field readonly clickable v-model="form.companyName" @click="!form.boId?'':isFixed?isZfcq?showPicker('company'):'':showPicker('company')" label="我方签约主体机构" :rules="[{ required: true }]" placeholder="请先选择客户商机再选择我方签约主体机构" required />
      <van-field readonly clickable v-model="form.bankAccountName" @click="form.companyName?showPicker('bankAccount'):''" label="收款银行账号" :rules="[{ required: true }]" placeholder="请先选择我方签约主体机构" required />
      <van-field readonly clickable v-model="form.deptName" label="我方签约部门" :rules="[{ required: true }]" placeholder="请选择我方签约部门" required @click="showCascader('dept')" />
      <van-field readonly clickable v-model="form.userName" label="我方签约人" placeholder="请选择我方签约人" :rules="[{ required: true }]" required @click="form.deptId?showPicker('userName'):''" />
      <van-field v-model="form.boName" label="客户商机" placeholder="请选择商机名称" readonly @click="form.userId?showPicker('boId'):''" :rules="[{ required: true }]" required >
        <template #button v-if="!form.boName">
          <van-button icon="plus" type="info" native-type="button" size="mini" @click.stop="addBo">新增商机</van-button>
        </template>
      </van-field>
      <!-- <van-field v-model="form.businessTypeName" label="业务类型" placeholder="请先选择客户商机" readonly /> -->
      <van-field v-model="form.custName" label="客户名称" placeholder="请先选择客户商机" readonly />
      <van-field v-model="form.contractName" label="合同标题" placeholder="请先选择客户商机" readonly />

      <van-cell-group class="radioGroup">
        <van-cell title="合同模板：">
          <template>
            <van-radio-group v-model="form.templateType" direction="horizontal" @change="radioChange">
              <div v-for="(item,index) in radioOption.templateTypeOptions" :key="index">
                <van-radio :name="item.dictValue" clickable @click="form.templateType = item.dictValue">{{item.dictLabel}}</van-radio>
              </div>
            </van-radio-group>
          </template>
        </van-cell>
        <div v-if="isVendite">
          <van-cell title="框架类型：">
            <template>
              <van-radio-group v-model="form.frameType" direction="horizontal" @change="radioChange">
                <div v-for="(item,index) in radioOption.frameTypeOptions" :key="index">
                  <van-radio :name="item.dictValue" clickable @click="form.frameType = item.dictValue">{{item.dictLabel}}</van-radio>
                </div>
              </van-radio-group>
            </template>
          </van-cell>
          <van-cell title="垫款方式：">
            <template>
              <van-radio-group v-model="form.payType" direction="horizontal" @change="radioChange">
                <div v-for="(item,index) in radioOption.payTypeOptions" :key="index">
                  <van-radio :name="item.dictValue" clickable @click="form.payType = item.dictValue">{{item.dictLabel}}</van-radio>
                </div>
              </van-radio-group>
            </template>
          </van-cell>
          <van-cell title="客户来源：">
            <template>
              <van-radio-group v-model="form.custSource" direction="horizontal" @change="radioChange">
                <div v-for="(item,index) in radioOption.custSourceOptions" :key="index">
                  <van-radio :name="item.dictValue" clickable @click="form.custSource = item.dictValue">{{item.dictLabel}}</van-radio>
                </div>
              </van-radio-group>
            </template>
          </van-cell>
        </div>
      </van-cell-group>
    </van-form>
    <van-form ref="basicsForm" validate-trigger="onSubmit" class="" v-if="active == 1">
      <van-field v-model="form.companyName" label="我方签约主体机构" readonly />
      <van-field v-model="form.contractName" label="合同标题" readonly />
      <van-field v-model="form.businessTypeName" label="业务类型" readonly />
      <van-field v-model="form.custName" label="客户名称" readonly />
      <van-field v-model="form.executionTime" readonly clickable name="calendar" label="合同执行时间" placeholder="点击选择合同执行时间" @click="showCalendar('executionTime')" required />
      <van-cell v-if="form.businessTypeName.indexOf('数字技术类') > -1" title="提示信息：数字技术类合同执行时间要按与客户合作项目的时间预计，若有延长由部门管理人员相应更改合同执行时间。" style="color: #ff976a;"></van-cell>
      <div v-if="isVendite && form.payType == 2">
        <van-field v-model="form.advancesCycle" label="垫款事由" placeholder="请输入垫款事由" :rules="[{ required: true }]" required />
        <!-- <van-field v-model="form.advancesProject" label="垫款项目" placeholder="请输入垫款项目" :rules="[{ required: true }]" required /> -->
        <van-field v-model="form.advancesMoney" label="授信总额" placeholder="请输入授信总额" @blur="getSum('advancesMoney')" :rules="[{ required: true }]" required />
        <van-cell v-if="form.advancesMoney" title="" :value="toChineseBig(form.advancesMoney)" />
        <!-- <van-field v-model="form.collectionPeriod" label="回款账期(天)" placeholder="请输入回款账期(天)" type="digit" maxlength="5" /> -->
        <van-field v-model="form.creditCycleTypeName" label="授信账期类型" placeholder="请选择授信账期类型" readonly clickable  @click="showPicker('creditCycleType')" :rules="[{ required: true }]" required/>
        <van-field v-model="form.creditCycleValue" label="授信账期时间(天)" placeholder="请输入授信账期时间(天)" type="digit" maxlength="5" :rules="[{ required: true }]" required />
        <!-- <van-field v-model="form.creditMoney" label="授信金额(元)" placeholder="请输入授信金额" @blur="getSum('creditMoney')" :rules="[{ required: true }]" type="number" maxlength="11" required /> -->
        <!-- <van-field v-model="form.creditTotalMoney" label="累计授信总金额" placeholder="请输入累计授信总金额" type="number" @blur="getSum('creditTotalMoney')" maxlength="11" :rules="[{ required: true }]" required /> -->
      </div>
      <van-field v-model="form.contractMoney" label="合同总金额" placeholder="请输入合同金额" @blur="getSum('contractMoney')" :rules="[{ required: true }]" type="number" maxlength="11" required />
      <van-cell v-if="form.contractMoney" title="" :value="toChineseBig(form.contractMoney)" />
      <van-field v-model="form.invoicingMethodName" label="开票方式" placeholder="请选择开票方式" readonly clickable  @click="showPicker('invoicingMethod')" :rules="[{ required: true }]" required />
      <van-field v-model="form.invoiceTypeName" label="发票类型" placeholder="请选择发票类型" readonly clickable  @click="showPicker('invoiceType')" :rules="[{ required: true }]" required />
      <van-cell title="是否授权户" required v-if="form.businessTypeName.indexOf('数字技术类') == -1 && form.businessTypeName.indexOf('数字营销运营类') == -1 && form.businessTypeName.indexOf('品牌推广类') == -1">
        <template>
          <van-radio-group v-model="form.isAuth" direction="horizontal">
            <van-radio name="0" clickable @click="form.isAuth = '0'">否</van-radio>
            <van-radio name="1" clickable @click="form.isAuth = '1'">是</van-radio>
          </van-radio-group>
        </template>
      </van-cell>
      <!-- <van-field v-model="form.signedMainTypeName" label="我方签约主体地位" placeholder="请选择我方签约主体地位" readonly clickable  @click="showPicker('signedMainType')" /> -->

      <div v-if="isVendite">
        <!-- <van-field v-model="form.payCycle" label="付款周期(天)" placeholder="请输入付款周期(天)" type="digit" maxlength="5" /> -->
        <van-field v-model="form.operationModeName" label="运营方式" placeholder="请选择运营方式" readonly clickable  @click="showPicker('operationMode')" :rules="[{ required: true }]" required />
        <van-field v-model="form.mediaTypeName" label="媒介归属" placeholder="请选择媒介归属" readonly clickable  @click="showPicker('mediaType')" :rules="[{ required: true }]" required />
        <!-- <van-field v-model="form.cooperationPolicyName" label="合作政策" placeholder="请选择合作政策" readonly clickable  @click="showPicker('cooperationPolicy')" /> -->
      </div>
      <van-field
        v-model="form.content"
        rows="2"
        autosize
        label="备注"
        placeholder="请输入备注"
        type="textarea"
        show-word-limit
      />
      <!-- <van-field v-model="form.useSealTime" v-if="form.templateType == 2" readonly clickable name="calendar" label="用印日期" placeholder="点击选择用印日期" @click="showCalendar('useSealTime')" :rules="[{ required: true }]" required />
      <van-field v-model="form.advancesCycle" v-if="form.templateType == 2 && form.payType != 2" label="用印事由" placeholder="请输入用印事由" :rules="[{ required: true }]" required /> -->

      <!-- <van-field v-model="form.boName" label="客户商机" placeholder="请选择商机名称" readonly clickable  @click="showPicker('boId')" required />
      <van-cell title="大写" value="一二三" />
      <van-field v-model="form.custName" label="我方签约主体机构" placeholder="请选择我方签约主体机构" readonly /> -->
<!-- :rules="[{ required: true,pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！'}]" type="tel" -->
    </van-form>
    <van-form ref="enclosureForm" validate-trigger="onSubmit" class="" v-if="active == 2">
      <van-field v-model="form.signedUser" label="对方签约人" placeholder="请输入对方签约人" :rules="[{ required: true }]" required />
      <van-field v-model="form.signedUserMobile" label="对方电话" placeholder="请输入对方签约人电话" :rules="[
                { required: true, message: '请输入对方签约人电话' }]" required />
                <!-- { pattern: /^[0-9-]+$/g, message: '手机或电话号码格式错误！'} -->
      <van-field v-model="form.signedUserEmail" label="对方邮箱" placeholder="请输入对方签约人邮箱" />
      <van-field v-model="form.signedUserWx" label="对方微信" placeholder="请输入对方签约人微信号" />
      <!-- <van-field v-model="form.deptName" label="我方签约部门"  readonly />
      <van-field v-model="form.userName" label="我方签约人" readonly /> -->
      <van-field v-model="form.signTime" readonly clickable name="calendar" label="签约时间" placeholder="点击选择签约时间" @click="showCalendar('signTime')" :rules="[{ required: true }]" required />
      <van-field v-model="form.deliveryTime" readonly clickable name="calendar" label="交付日期" placeholder="点击选择交付日期" @click="showCalendar('deliveryTime')" />
      <van-field v-model="form.infoDeptName" label="信息提供部门" placeholder="请选择信息提供部门" readonly clickable @click="showCascader('infoDept')" />
      <van-field v-model="form.infoUserName" label="信息提供人" placeholder="请先选择信息提供部门" readonly clickable @click="form.infoDeptId?showPicker('infoUserName'):''" />
      <van-field v-model="form.filingDate" readonly clickable name="calendar" label="归档日期" placeholder="点击选择归档日期" @click="showCalendar('filingDate')" :rules="[{ required: true }]" required />
      <van-cell title="提示信息：请按实际情况填写合同预计归档日期，且自合同审批通过之后最长不超过30个自然日合同必须归档至总经办相关人员处，逾期将扣除绩效奖金50元/份；特殊情况需经总经办审批。" style="color: #ff976a;"></van-cell>
      <!-- <van-field v-model="form.useSealTime" v-if="form.templateType == 2" readonly label="申请用印日期" /> -->

    </van-form>
    <van-form ref="pointForm" validate-trigger="onSubmit" class="" v-if="active == 3">
      <template v-if="form.businessTypeName.indexOf('数字技术类') === -1 && form.businessTypeName.indexOf('品牌推广类') === -1">
        <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o" class="notice_bar" :scrollable="false" mode="closeable">
          合同运营方式为代运营时，媒体版位、投放链路必填。
        </van-notice-bar>
        <van-field v-model="form.mediaLocationName" label="媒体版位" placeholder="请选择媒体版位" readonly clickable @click="showTreeSelect('mediaLocation')" :rules="form.operationMode == '2'?[{ required: true }]:[]" :required="form.operationMode == '2'" />
        <div v-if="form.mediaLocationNames" class="tagArr">
          <!-- <van-tag v-if="item" :closable="true" @close="deleteMediaLocation(index)">{{item}}</van-tag> -->
          <!-- v-if="form.businessTypeName.indexOf('效果运营类') > -1" -->
          <van-tag v-for="(item,index) in form.mediaLocationNames.split(',')" :key="index" color="#1989fa">{{item}}</van-tag>
        </div>
        <van-field v-model="form.deliveryLinkName" label="投放链路" placeholder="请选择投放链路" readonly clickable @click="showTreeSelect('deliveryLink')" :rules="form.operationMode == '2'?[{ required: true }]:[]" :required="form.operationMode == '2'" />
        <div v-if="form.deliveryLinkNames" class="tagArr">
          <!-- <van-tag v-if="item" :closable="true" @close="deleteMediaLocation(index)">{{item}}</van-tag> -->
          <van-tag v-for="(item,index) in form.deliveryLinkNames.split(',')" :key="index" color="#1989fa">{{item}}</van-tag>
        </div>
        <van-field v-model="form.openAccountFee" label="开户服务费" placeholder="请输入开户服务费(若无填0)"  @blur="getSum('openAccountFee')" type="number" maxlength="11" :rules="[{ required: true }]" required />
        <van-field v-model="form.agentBussFee" label="代运营服务费" placeholder="请输入代运营服务费(若无填0)" @blur="getSum('agentBussFee')" type="number" maxlength="11" :rules="[{ required: true }]" required >
          <template slot="right-icon">%</template>
        </van-field>
        <van-field v-model="form.materialMoney" label="素材费" placeholder="请输入素材费(若无填0)"  @blur="getSum('materialMoney')" type="number" maxlength="11" :rules="[{ required: true }]" required />
      </template>
      <template v-if="form.custSource == 1">
        <van-button style="margin-top: 10px" class="topBtn" round block type="primary" native-type="button" size="small" @click="addProject">+添加项目</van-button>
        <van-list v-if="projectList.length > 0" style="margin-top: -50px">
          <!-- <van-cell-group>
            <van-cell v-for="(item,index) in projectList" :title="item.projectName" :key="index" style="padding-top: 20px;padding-bottom: 20px">
              <template #right-icon>
                <van-button type="info" size="mini" plain @click="handleProjectPoint(item)">返点</van-button>
                <van-button type="info" size="mini" plain @click="handleProjectUpdate(item,index)">修改</van-button>
                <van-button size="mini" color="#ee0a24" plain @click="handleProjectDelete(item)">删除</van-button>
              </template>
            </van-cell>
          </van-cell-group> -->
          <van-cell-group v-for="(item,index) in projectList" :key="index" style="padding-bottom: 10px;">
            <div class="flex-c-center" v-if="item">
              <div style="flex: 1">
                <div style="color: #666;font-size: 14px;padding: 10px 20px;line-height: 22px">
                  <span style="color: #333;">{{item.projectName}}</span>
                </div>
              </div>
            </div>
            <div class="btns">
              <van-button type="info" size="mini" @click="handleProjectPoint(item)">返点</van-button>
              <van-button type="warning" size="mini" @click="handleProjectUpdate(item,index)">修改</van-button>
              <van-button size="mini" color="#ee0a24" v-hasPermi="['cont:project:remove']" @click="handleProjectDelete(item)">删除</van-button>
            </div>
            <!-- <van-cell  style="padding-top: 20px;padding-bottom: 20px">
              <template #right-icon>
                <van-button type="warning" size="mini" plain @click="selectContract(item)">选择</van-button>
              </template>
            </van-cell> -->
          </van-cell-group>
        </van-list>
      </template>
      <!-- <van-collapse v-model="activeNamesP">
        <van-collapse-item :title="index == 0?'返点':'阶梯返点'+(index)" :name="index" v-for="(item,index) in pointList" :key="index+'01'">
          <van-field v-model="item.projectName" @click="selectProject(index)" label="项目名称" placeholder="点击选择项目名称" type="text" :rules="[{ required: true }]" required />
          <van-field v-model="item.percentage" label="返点百分比" placeholder="请输入返点百分比(若无填0)" type="number" :rules="[{ required: true }]" required >
            <template slot="right-icon">%</template>
          </van-field>
          <van-field v-model="item.useMoney" label="返点消耗" :placeholder="index == 0?'无需输入,阶梯返点请增加返点':'返点消耗'" type="number" maxlength="13" @blur="fixValue(item.useMoney,index)" :disabled="index == 0" :rules="index == 0?[]:[{ required: true }]" :required="index == 0?false:true">
            <template slot="label">返点消耗<span class="dayuxiaoyufu">{{pointList.length > 1?index == 0?'<':'≥':''}}</span></template>
            <template slot="right-icon">￥</template>
          </van-field>
          <van-field v-model="item.startTime" label="执行开始时间" placeholder="请选择执行开始时间" readonly clickable @click="showTimePicker('startTime',index)" />
          <van-field v-model="item.endTime" label="执行结束时间" placeholder="请选择执行结束时间" readonly clickable @click="showTimePicker('endTime',index)" />
          <div class="link">
            <van-button class="linkaddBtn" round block type="primary" native-type="button" size="small" @click="addPoint">+增加返点</van-button>
            <van-button class="linkaddBtn" round block type="warning" native-type="button" size="small" @click="deletePoint(index)" v-if="index != 0">删除</van-button>
          </div>
        </van-collapse-item>
      </van-collapse> -->
    </van-form>
    <van-form ref="contactForm" validate-trigger="onSubmit" class="" v-if="active == 4">
      <van-button v-if="form.fileList.length == 0" class="topBtn" round block type="primary" native-type="button" size="small" @click="addEnclosure">+增加附件</van-button>
      <van-collapse v-model="activeNamesC">
        <van-collapse-item :title="'附件'+(index+1)" :name="index" v-for="(item,index) in form.fileList" :key="index+'01'">
          <!-- <van-field v-model="item.title" label="附件标题" placeholder="请输入附件标题" :rules="[{ required: true }]" required /> -->
          <!-- <van-field v-model="item.amount" label="变动金额(元)" placeholder="请输入变动金额" @focus="getFocus(index)" @blur="getSum('amount',index)" type="number" maxlength="11" /> -->
          <van-field v-model="item.fileTypeName" label="附件类型" placeholder="请选择附件类型" readonly clickable  @click="showPicker('fileType',index)" :rules="[{ required: true }]" required />
          <van-field
            v-model="item.fileDesc"
            rows="2"
            autosize
            label="附件描述"
            placeholder="请输入附件描述"
            type="textarea"
            show-word-limit
          />
          <van-field v-model="item.url" label="上传附件" placeholder="需要上传的文件" readonly @click="getIndex(index)" :rules="[{ required: true }]" required >
            <template #button>
              <van-uploader :after-read="uploadContractPictureFiles" :before-read="beforeRead" :max-size="10000 * 1024" @oversize="onOversize" accept="application/pdf,.doc,.docx,">
                <van-button icon="plus" type="info" size="mini"></van-button>
              </van-uploader>
              <van-button round size="mini" color="#ee0a24" native-type="button" @click="viewFileTip" style="margin-left: 10px;padding: 0 7px;font-size: 14px">?</van-button>
            </template>
          </van-field>
          <div class="attachment_link">
            <a v-if="item.url" :href="item.url" @click="downloadUrlFile(item.url,item.title + '附件')">{{item.fileName}}    查看附件</a>
          </div>
          <!-- <a v-if="item.url" :href="item.url" @click="downloadUrlFile(item.url,item.title + '附件')">查看附件</a> -->
          <div class="link">
            <van-button class="linkaddBtn" round block type="primary" native-type="button" size="small" @click="addEnclosure">+增加附件</van-button>
            <van-button class="linkaddBtn" round block type="warning" native-type="button" size="small" @click="deleteE(index)">删除</van-button>
          </div>
        </van-collapse-item>
      </van-collapse>
    </van-form>
    <van-form ref="payAgreeForm" validate-trigger="onSubmit" class="" v-if="active == 5">
      <van-button v-if="form.contPayAgreeList.length == 0" class="topBtn" round block type="primary" native-type="button" size="small" @click="addPayment">+增加收款约定</van-button>
      <van-collapse v-model="activeNames">
        <van-collapse-item :title="'收款约定'+(index+1)" :name="index" v-for="(item,index) in form.contPayAgreeList" :key="index+'01'">
          <van-field v-model="item.contPayTypeName" label="款项内容" placeholder="请选择款项内容" readonly clickable  @click="showPicker('contPayType',index)" :rules="[{ required: true }]" required />
          <van-field v-model="item.payTime" readonly clickable name="calendar" label="付款日期" placeholder="点击选择付款日期" @click="showCalendar('payTime',index)" :rules="[{ required: true }]" required />
          <van-field v-model="item.custName" label="付款单位"  readonly />
          <van-field v-model="item.companyName" label="收款合同方" readonly />
          <van-field v-model="item.entrustCustName" label="委托付款单位" placeholder="请选择委托付款单位" readonly clickable @click="showCustList(index)" :rules="[{ required: true }]" required />
          <van-field v-model="item.payCondition" label="付款条件" placeholder="请输入付款条件" />
          <van-field v-model="item.advancesMoney" label="付款金额(元)" placeholder="请输入付款金额" @focus="getFocus(index)" @blur="getSum('advancesMoney',index)" type="number" maxlength="11" :rules="[{ required: true }]" required />
          <van-field
            v-model="item.remark"
            rows="2"
            autosize
            label="备注"
            placeholder="请输入备注"
            type="textarea"
            show-word-limit
          />
          <div class="link">
            <van-button class="linkaddBtn" round block type="primary" native-type="button" size="small" @click="addPayment">+增加收款约定</van-button>
            <van-button class="linkaddBtn" round block type="warning" native-type="button" size="small" @click="deleteT(index)">删除</van-button>
          </div>
        </van-collapse-item>
      </van-collapse>
    </van-form>
    <div class="bottomBtn" >
      <!-- <div class="remark" v-if="(contractNumCount || contractNumCount === 0) && form.templateType != 2">当前可使用合同编号数量：{{contractNumCount}}份</div> -->
      <div class="btnGroup">
        <van-button style="flex: 0.3" v-if="active != 0" class="addBtn" round block type="primary" native-type="button" size="small" @click="backStep">上一步</van-button>
        <van-button style="flex: 0.3" class="addBtn" round block type="info" native-type="button" size="small"  @click="nextStep">{{active == 0?'下一步':active == 5?'保存':'保存下一步'}}</van-button>
        <!-- <van-button style="flex: 0.3" v-if="active == 4 || active == 5" class="addBtn" round block type="info" native-type="button" size="small"  @click="nextStep('tj')">提交</van-button> -->
        <van-button style="flex: 0.3" v-if="active == 4 || active == 5" class="addBtn" round block color="#ee0a24" native-type="button" size="small" @click="closeGo">关闭</van-button>
        <!-- v-preventReClick -->
      </div>
    </div>

    <van-popup v-model="datetimePicker.showDate" position="bottom">
      <van-datetime-picker v-model="datetimePicker.date" type="datetime" :title="datetimePicker.title" :min-date="datetimePicker.minDate" @confirm="datetimePickerConfirm" @cancel="datetimePicker.visible = false" />
    </van-popup>
    <van-popup v-model="tree.typeTree" position="bottom">
      <van-cascader :title="tree.title" :options="tree.treeList" :field-names="tree.fieldNames" @change="treeChange" @close="tree.typeTree = false" @finish="onFinishTree" />
    </van-popup>
    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
    </van-popup>
    <van-calendar v-model="datePicker.showDate" :min-date="datePicker.minDate" :max-date="datePicker.maxDate" :type="datePicker.type" @confirm="dateConfirm" />
    <select-customer :show='select_show' @handleCancel='handleCancel' @beforeClose='selectBeforeClose'></select-customer>

    <van-popup v-model="mediaSelect" position="bottom">
      <van-tree-select :items="treeItems" :active-id.sync="mediaActiveIds" :main-active-index.sync="treeActiveIndex" @click-item="chooseTree" />
      <van-button block type="info" native-type="button" size="small" @click="mediaSelect = false">完成</van-button>
    </van-popup>
    <van-popup v-model="deliverySelect" position="bottom">
      <van-tree-select :items="treeItems" :active-id.sync="deliveryActiveIds" :main-active-index.sync="treeActiveIndex" @click-item="chooseTree" />
      <van-button block type="info" native-type="button" size="small" @click="deliverySelect = false">完成</van-button>
    </van-popup>
    <dialog-add :show='add_show' :modifyObj="customer" :isAdd='true' @handleAddBoCancel='handleAddBoCancel' @beforeClose='addBoBeforeClose' ></dialog-add>
    <van-dialog v-model="showFileTip" title="附件选择文件说明" width='80%' confirmButtonText="关闭">
      <div class="file_tip">
        <div>IOS手机选择文件：</div>
        第一步，打开微信，点击需要保存的文件。
        第二步，进入该文件后，点击更多图标。
        第三步， 在菜单栏内选择“用其他应用打开”。
        第四步，选择“存储到“文件””。
        第五步，此时已经进入了“iCloud 云盘”，选择希望存储在的文件夹内即可。此例选择存入“文本编辑”。
        这样，微信内的文件就存储在了iOS系统的“文件”app内了。
      </div>
    </van-dialog>

    <!-- 选择项目名称弹窗 -->
    <cont-project-name :contractId="form.contractId" :projectId="projectForm.projectId" :selectProjectVisible="selectProjectVisible" :isFirst="isFirst" @confirm="setProjectName"></cont-project-name>
    <!-- 项目名称返点弹窗 -->
    <project-point :setPointVisible="setPointVisible" :contractId="form.contractId" :projectId="projectForm.projectId" :projectName="projectForm.projectName" @savePoint="setProjectPoint"></project-point>
  </div>
</template>

<script>
import { getUser } from '@/api/system/user'
import newContract from '@/api/cont/newContract'
import payment from '@/api/cont/payment'
import { getDicts } from '@/api/system/dict/data'
import { Toast, Tag, Cascader, TreeSelect, Dialog, NoticeBar, DatetimePicker } from 'vant'
import { businessTypeList, CascaderTreeSelect, listAddContract, treeselect } from '@/api/admi/dept' // companyList
import { selectDeptIdByUserList } from '@/api/admi/user'
import SelectCustomer from '@/components/common/SelectCustomer'
import DialogAdd from '@/views/scrm/component/DialogAddBo.vue'
import ContProjectName from '@/views/cont/components/ContProjectName.vue'
import ProjectPoint from '@/views/cont/components/ProjectPoint.vue'
export default {
  name: 'contractAdd',
  components: {
    [Toast.name]: Toast,
    [Tag.name]: Tag,
    [TreeSelect.name]: TreeSelect,
    [Dialog.Component.name]: Dialog.Component,
    [NoticeBar.name]: NoticeBar,
    [DatetimePicker.name]: DatetimePicker,
    vanCascader: Cascader,
    SelectCustomer,
    DialogAdd,
    ContProjectName,
    ProjectPoint
  },
  data() {
    return {
      index: null,
      active: 0,
      isFixed: false, // 是否修改
      isZfcq: false, // 是否作废重签
      isVendite: false, // 是否是 销售/数字技术类
      tree: {
        type: '',
        title: '',
        typeTree: false,
        treeList: [],
        fieldNames: {

        }
      },
      add_show: false,
      showDept: false,
      companyList: [],
      serviceTypeTreeList: [],
      deptUserList: [],
      custBoList: [],
      deptTreeList: [],
      contractNumCount: '0',
      amountWords: '',
      pointList: [],
      form: {
        userName: '',
        userId: '',
        useSealTime: null,
        templateType: '1',
        frameType: '1',
        payType: '1',
        custSource: '1',
        payCycle: '',
        startTime: '',
        endTime: '',
        deptName: '',
        deptId: '',
        custName: '',
        custId: '',
        cooperationPolicy: '',
        contractName: '',
        contractMoney: '',
        contractId: null,
        content: '',
        isAuth: '0',
        contPayAgreeList: [
          // {
          //   contractId: null,
          //   contPayType: '',
          //   payTime: '',
          //   payCondition: '',
          //   contractMoney: '',
          //   companyName: '',
          //   companyId: '',
          //   custName: '',
          //   custId: '',
          //   entrustCustName: '',
          //   entrustCustId: ''
          // }
        ],
        fileList: [
          // {
          //   contractId: null,
          //   title: '',
          //   amount: '',
          //   fileType: '',
          //   fileDesc: '',
          //   url: ''
          // }
        ],
        companyName: '',
        companyId: '',
        bankAccountId: '', // 收款银行账号
        bankAccountName: '',
        businessTypeName: '',
        businessTypeId: '',
        boName: '',
        boId: '',
        signedMainType: '',
        mediaType: '',
        operationMode: '',
        invoicingMethod: '',
        invoiceType: '',
        creditMoney: null, // 授信金额
        creditCycleValue: null, // 授信账期时间
        creditCycleType: null, // 授信账期类型：1 自然日 2 工作日 3 自然月
        advancesCycle: null, // 垫款事由
        collectionPeriod: null // 回款账期(天)
      },
      payBankList: [], // 收款银行列表
      select_show: false,
      radioOption: {
        templateTypeOptions: [],
        frameTypeOptions: [],
        custSourceOptions: [],
        payTypeOptions: []
      },
      options: {
        mediaTypeOptions: [],
        cooperationPolicyOptions: [],
        operationModeOptions: [],
        invoicingMethodOptions: [],
        invoiceTypeOptions: [],
        signedMainTypeOptions: [],
        contPayTypeOptions: [],
        fileTypeOptions: [],
        mediaLocationOptions: [],
        deliveryLinkOptions: []
      },
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      datePicker: {
        showDate: false,
        minDate: new Date(2020, 0, 1),
        maxDate: new Date(2042, 11, 31),
        type: 'single',
        formKey: ''
      },
      datetimePicker: {
        showDate: false,
        minDate: new Date(2020, 0, 1),
        // maxDate: new Date(2042, 11, 31),
        formKey: '',
        title: ''
      },
      mediaSelect: false,
      deliverySelect: false,
      typeTree: '',
      treeActiveIndex: 0,
      mediaActiveIds: [],
      deliveryActiveIds: [],
      treeItems: [],
      executionTime: '', // 执行时间
      activeNames: [0],
      activeNamesC: [0],
      activeNamesP: [0],
      customer: {},
      showFileTip: false,

      // 选择项目名称
      selectProjectVisible: false,
      isFirst: false,
      projectForm: { projectId: null },
      projectList: [],

      // 项目名称返点
      setPointVisible: false
    }
  },
  async created() {
    if (this.$route.query.isZfcq) {
      this.isZfcq = this.$route.query.isZfcq
    }
    if (this.$route.query.customer) {
      this.customer = JSON.parse(this.$route.query.customer)
    }
    await this.getRadioOptions()
    this.form.deptId = this.$store.state.user.user.deptId
    await treeselect().then((response) => {
      const dept = this.getParent(response.data, this.form.deptId)
      dept.map((item) => {
        this.form.deptName += item.label + '/'
      })
      this.form.deptName = this.form.deptName.substring(0, this.form.deptName.length - 1)
    })
    this.form.userName = this.$store.state.user.user.nickName
    this.form.userId = this.$store.state.user.user.userId
    console.log(this.radioOption)
    // this.getTagList()
    if (this.$route.query.contractId) {
      this.getOptions()
      // this.active = 1
      this.isFixed = true
      await this.getContract(this.$route.query.contractId)
      await this.getListPoint(this.$route.query.contractId)
      await this.getListContractFile(this.$route.query.contractId)
      await this.getListPayAgree(this.$route.query.contractId)
    }

    // 商业页面跳转
    if (this.$route.query.boName) {
      this.form = { ...this.form, ...this.$route.query }
      this.form.contractName = this.$route.query.boName
      this.form.userName = this.$route.query.userName
      const name = this.form.businessTypeName.split('/')
      if (name[0] == '销售' && name[1] == '数字技术类') {
        this.isVendite = false
      } else {
        this.isVendite = true
      }
      const res = await getUser(this.$route.query.userId)
      if (res.code === 200) {
        // this.form.deptName = res.data.deptName
        this.form.deptId = res.data.dept.deptId
      }
      await treeselect().then((response) => {
        const dept = this.getParent(response.data, this.form.deptId)
        dept.map((item) => {
          this.form.deptName += item.label + '/'
        })
        this.form.deptName = this.form.deptName.substring(0, this.form.deptName.length - 1)
      })
      // await companyList().then((response) => {
      //   this.form.companyName = response.rows[0].companyName
      //   this.form.companyId = response.rows[0].companyId
      // })
      await listAddContract({ businessTypeId: this.form.businessTypeId }).then((response) => {
        this.companyList = response.rows
      })
      // await this.getContCount()
      console.log(this.form)
    }
  },
  mounted() {
    this.init()
    payment.listPayBank({ companyId: this.$route.query.companyId }).then(res => {
      if (res.code === 200 && res.rows.length > 0) {
        this.payBankList = res.rows
      }
    })
  },
  methods: {
    formBankAccount(name, val) {
      const ele = this.payBankList.find(res => { return res.bankAccountId == val })
      return `${ele.bankName}(${ele.accountNum})`
    },
    fixValue(val, index) {
      if (index == 1) {
        this.pointList[0].useMoney = val
      }
      if (Number(val) < Number(this.pointList[index - 1].useMoney)) {
        Toast.fail('当前金额不能小于上一个金额')
        this.pointList[index].useMoney = ''
      }
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    getParent(data2, nodeId2) {
      var arrRes = []
      if (data2.length == 0) {
        if (nodeId2) {
          arrRes.unshift(data2)
        }
        return arrRes
      }
      const rev = (data, nodeId) => {
        for (var i = 0, length = data.length; i < length; i++) {
          const node = data[i]
          if (node.id == nodeId) {
            arrRes.unshift(node)
            rev(data2, node.parentId)
            break
          } else {
            if (node.children) {
              rev(node.children, nodeId)
            }
          }
        }
        return arrRes
      }
      arrRes = rev(data2, nodeId2)
      return arrRes
    },
    async getContract(contractId) {
      const res = await newContract.getContract(contractId)
      if (res.code === 200) {
        console.log(res.data)
        this.form = res.data
        this.getProjectList()
        // if (this.form.fileList.length == 0) {
        //   this.form.fileList = [{
        //     contractId: null,
        //     title: '',
        //     amount: '',
        //     fileType: '',
        //     fileDesc: '',
        //     url: ''
        //   }]
        // }
        // if (this.form.contPayAgreeList.length == 0) {
        //   this.form.contPayAgreeList = [{
        //     contractId: null,
        //     contPayType: '',
        //     payTime: '',
        //     payCondition: '',
        //     contractMoney: '',
        //     companyName: '',
        //     companyId: '',
        //     custName: '',
        //     custId: '',
        //     entrustCustName: '',
        //     entrustCustId: ''
        //   }]
        // }
        if (this.form.remark == '作废重签') {
          this.isZfcq = true
        }
        this.form.templateType = this.form.templateType.toString()
        this.form.payType = this.form.payType.toString()
        this.form.frameType = this.form.frameType.toString()
        this.form.custSource = this.form.custSource ? this.form.custSource.toString() : null
        // this.form.nickName = this.form.nickName
        this.form.boName = this.form.contractName
        const name = this.form.businessTypeName.split('/')
        if (name[0] == '销售' && name[1] == '数字技术类') {
          this.isVendite = false
        } else {
          this.isVendite = true
        }

        this.form.executionTime = `${this.form.startTime} 至 ${this.form.endTime}`
        this.form.invoicingMethodName = this.formatHandel('invoicingMethod', this.form.invoicingMethod)
        this.form.invoiceTypeName = this.formatHandel('invoiceType', this.form.invoiceType)
        this.form.signedMainTypeName = this.formatHandel('signedMainType', this.form.signedMainType)
        this.form.mediaTypeName = this.formatHandel('mediaType', this.form.mediaType)
        this.form.cooperationPolicyName = this.formatHandel('cooperationPolicy', this.form.cooperationPolicy)
        this.form.operationModeName = this.formatHandel('operationMode', this.form.operationMode)
        this.form.creditCycleTypeName = this.formatHandel('creditCycleType', this.form.creditCycleType)
        this.amountWords = this.toChineseBig(this.form.contractMoney)
        // this.mediaActiveIds = this.form.mediaLocationIds.split(',')
        this.form.mediaLocationName = this.form.mediaLocationNames
        // this.deliveryActiveIds = this.form.deliveryLinkIds.split(',')
        this.form.deliveryLinkName = this.form.deliveryLinkNames
        this.form.bankAccountName = this.formBankAccount('bankAccountId', this.form.bankAccountId)
      }
    },
    async getListPoint(contractId) {
      const res = await newContract.getRebateList({ contractId: contractId })
      if (res.code === 200) {
        if (res.rows.length != 0) {
          this.pointList = res.rows
          this.pointList.map(item => {
            item.zxTime = `${item.startTime} 至 ${item.endTime}`
          })
        }
      }
    },
    async getListContractFile(contractId) {
      const res = await newContract.listContractFile({ contractId })
      const that = this
      if (res.code === 200) {
        if (res.rows.length != 0) {
          this.form.fileList = res.rows
          await that.form.fileList.forEach(function(value, index, array) {
            that.form.fileList[index].fileTypeName = that.formatHandel('fileType', Number(that.form.fileList[index].fileType))
          })
        }
      }
    },
    async getListPayAgree(contractId) {
      const res = await newContract.listPayAgree({ contractId })
      const that = this
      if (res.code === 200) {
        console.log(res.rows)
        if (res.rows.length != 0) {
          this.form.contPayAgreeList = res.rows
          await that.form.contPayAgreeList.forEach(function(value, index, array) {
            that.form.contPayAgreeList[index].contPayTypeName = that.formatHandel('contPayType', Number(that.form.contPayAgreeList[index].contPayType))
          })
        }
      }
    },
    radioChange() {
      // if (this.form.templateType != 2) {
      //   if (this.form.businessTypeId) {
      //     this.getContCount()
      //   }
      // }
    },
    async getContCount() {
      const res = await newContract.getContractNum(this.form)
      if (res.code === 200) {
        this.contractNumCount = res.data
      } else {
        this.contractNumCount = 0
      }
    },
    getRadioOptions() {
      // 合同模板
      getDicts('template_type').then(res => {
        this.radioOption.templateTypeOptions = res.data
      })
      // 框架类型
      getDicts('frame_type').then(res => {
        this.radioOption.frameTypeOptions = res.data
      })
      // 客户来源类型
      getDicts('cust_source').then(res => {
        this.radioOption.custSourceOptions = res.data
      })
      // 垫款方式
      getDicts('pay_type').then(res => {
        this.radioOption.payTypeOptions = res.data
      })
      // 付款类型
      getDicts('cont_pay_type').then(res => {
        this.options.contPayTypeOptions = res.data
      })
      // 附件类型
      getDicts('file_type').then(res => {
        this.options.fileTypeOptions = res.data
      })
      // 授信账期类型
      getDicts('credit_cycle_type').then(res => {
        this.options.creditCycleTypeOptions = res.data
      })
    },
    getOptions() {
      // 媒介归属
      getDicts('media_type').then(res => {
        this.options.mediaTypeOptions = res.data
      })
      // 合作政策
      getDicts('cooperation_policy').then(res => {
        this.options.cooperationPolicyOptions = res.data
      })
      // 运营方式
      getDicts('operation_mode').then(res => {
        this.options.operationModeOptions = res.data
      })
      // 开票方式
      getDicts('Invoicing_method').then(res => {
        this.options.invoicingMethodOptions = res.data
      })
      // 发票类型
      getDicts('Invoice_type').then(res => {
        this.options.invoiceTypeOptions = res.data
      })
      // 我方主体地址
      getDicts('signed_main_type').then(res => {
        this.options.signedMainTypeOptions = res.data
      })
    },
    // 打开联级选择框
    async showCascader(val) {
      if (val === 'dept' || val === 'infoDept') {
        if (this.deptTreeList.length == 0) {
          await CascaderTreeSelect().then((response) => {
            this.deptTreeList = response.data
          })
        }
        this.tree = {
          type: val,
          title: '请选择部门',
          typeTree: true,
          treeList: this.deptTreeList,
          fieldNames: {}
        }
      } else if (val === 'service') {
        if (this.serviceTypeTreeLis.length == 0) {
          await businessTypeList({ pageNum: 1, pageSize: 500 }).then((response) => {
            if (response.code === 200) {
              this.serviceTypeTreeList = this.getData(response.rows)
            }
          })
        }
        this.tree = {
          type: val,
          title: '请选择业务类型',
          typeTree: true,
          treeList: this.serviceTypeTreeList,
          fieldNames: {
            text: 'businessTypeName',
            value: 'businessTypeId'
          }
        }
      }
    },
    // // 打开联级选择框
    // showPicker() {
    //   this.showDept = true
    // },
    // 去除树形数据的空children
    removeEmptyChildren(node) {
      node.forEach(item => {
        if ('children' in item && item.children.length === 0) {
          delete item.children
        } else if ('children' in item && item.children.length) {
          this.removeEmptyChildren(item.children)
        }
      })
      return node
    },
    /** 转换业务类型数据结构 */
    getData (arr) {
      // 利用两层filter实现
      const data = arr.filter(item => {
        item.children = arr.filter(e => {
          return item.businessTypeId === e.parentId
        })
        return !item.parentId
      })
      return this.removeEmptyChildren(data)
    },
    treeChange(obj) {
      if (this.tree.type === 'dept') {
        this.form.deptId = obj.value
        this.form.deptName = obj.selectedOptions.map((option) => option.text).join('/')
      } else if (this.tree.type === 'infoDept') {
        this.form.infoDeptId = obj.value
        this.form.infoDeptName = obj.selectedOptions.map((option) => option.text).join('/')
      }
    },
    onFinishTree(obj) {
      if (this.tree.type === 'service') {
        this.form.serviceTypeId = obj.value
        this.form.serviceTypeName = obj.selectedOptions.map((option) => option.businessTypeName).join('/')
      }
      this.tree.typeTree = false
    },
    backStep() {
      if (this.active == 0) {

      } else {
        this.active--
      }
    },
    // 下一步
    async nextStep() {
      // await this.$refs["form"].validate()
      // if(this.active == 4){
      //   this.form.contPayAgreeList[0].companyName = this.form.companyName
      //   this.form.contPayAgreeList[0].companyId = this.form.companyId
      //   this.form.contPayAgreeList[0].custName =this.form.custName
      //   this.form.contPayAgreeList[0].custId = this.form.custId
      //   return
      // }else{
      //   // this.active++
      //   if(this.active == 1){
      //     this.getOptions()
      //   }
      // }
      switch (this.active) {
        case 0:
          await this.$refs.cooperationForm.validate()
          // if (this.contractNumCount == 0 && this.form.templateType == 1 && !this.form.contractId) {
          //   Toast.fail('该类模板合同已无库存，请事业部合同管理员联系行政领取。')
          //   return
          // } else {
          //   await
          // }
          this.active++
          this.getOptions()
          break
        case 1:
          if (this.form.payType == '1') {
            this.form.creditMoney = null // 授信金额
            this.form.creditCycleValue = null // 授信账期时间
            this.form.creditCycleType = null // 授信账期类型：1 自然日 2 工作日 3 自然月
            // this.form.advancesCycle = null // 垫款事由
            this.form.collectionPeriod = null // 回款账期(天)
            this.form.creditTotalMoney = null
            this.form.advancesProject = null
            this.form.advancesMoney = null
          }
          if (this.form.frameType == 1 && this.form.contractMoney <= 0) {
            Toast.fail('合同金额必须大于0')
            return
          }
          if (!this.form.signedUser && !this.form.signedUserMobile) {
            const res = await newContract.getContacts({ custId: this.form.custId })
            if (res.code === 200) {
              if (res.data.length > 0) {
                this.form.signedUser = res.data[0].contactName
                this.form.signedUserMobile = res.data[0].mobile
                this.form.signedUserWx = res.data[0].weixinSn
                this.form.signedUserEmail = res.data[0].email
              }
            } else {
              Toast.fail(res.msg)
            }
          }
          this.$refs.basicsForm.validate().then(() => {
            this.form.stepId = 2
            if (!this.form.contractId) {
              newContract.addContract(this.form).then((res) => {
                if (res.code === 200) {
                  this.form.contractId = res.data.contractId
                  Toast.success('新增成功')
                  // this.getListPoint(this.form.contractId)
                  this.getProjectList()
                  this.form.stepId = null
                  this.active++
                } else {
                  Toast.fail(res.msg)
                }
              })
            } else {
              newContract.updateContract(this.form).then((res) => {
                if (res.code === 200) {
                  Toast.success('修改成功')
                  this.form.stepId = null
                  this.active++
                } else {
                  Toast.fail(res.msg)
                }
              })
            }
          }).catch(() => {
            const isError = document.getElementsByClassName('van-field--error') // 适用于vant
            isError[0].querySelector('.van-field__control').focus() // 只定位到第一个必填项位置
          })
          break
        case 2:
          { await this.$refs.enclosureForm.validate()
            this.form.stepId = 3
            const res = await newContract.updateContract(this.form)
            if (res.code === 200) {
              if (this.$route.query.contractId) {
                await Toast.success('修改成功')
              } else {
                await Toast.success('保存成功')
              }
              this.form.stepId = null
              this.active++
            } else {
              Toast.fail(res.msg)
            }
            if (this.pointList.length == 0) {
              this.pointList.push({
                contractId: this.form.contractId,
                projectName: null,
                percentage: '',
                useMoney: '',
                startTime: null,
                endTime: null
                // startTime: this.form.startTime,
                // endTime: this.form.endTime,
                // zxTime: this.form.executionTime
              })
            }
            // console.log(this.form.fileList)
          }
          break
        case 3:
          {
            if (this.form.businessTypeName.indexOf('效果运营类') > -1 || this.form.businessTypeName.indexOf('数字媒介类') > -1) {
              if (!this.form.openAccountFee && !this.form.agentBussFee && this.pointList.length == 0) {
                Toast.fail('开户服务费或代运营服务费或返点百分比必须填写其中一项')
                return
              }
            }
            await this.$refs.pointForm.validate()
            // if (this.pointList.length != 0) {
            //   const res2 = await newContract.addRebate(this.pointList, this.form.contractId)
            //   if (res2.code === 200) {
            //     await Toast.success('操作成功')
            //   } else {
            //     Toast.fail(res2.msg)
            //     return
            //   }
            // }
            const res = await newContract.updateContract(this.form)
            if (res.code === 200) {
              if (this.$route.query.contractId) {
                await Toast.success('修改成功')
              } else {
                await Toast.success('保存成功')
              }
              this.active++
            } else {
              Toast.fail(res.msg)
            }
          }
          break
        case 4:
          await this.$refs.contactForm.validate()
          if (this.form.fileList.length != 0) {
            const res2 = await newContract.addContractFile(this.form.fileList)
            if (res2.code === 200) {
              await Toast.success('操作成功')
              this.active++
            } else {
              Toast.fail(res2.msg)
            }
          } else {
            Toast.fail('上传附件后才能执行后续操作')
            this.active++
          }
          break
        case 5:
          await this.$refs.payAgreeForm.validate()
          if ((this.form.businessTypeName.indexOf('数字技术类') > -1 || this.form.businessTypeName.indexOf('品牌推广类') > -1) && this.form.contPayAgreeList.length == 0) {
            Toast.fail('请填写收款约定信息')
            return
          }
          if (this.form.contPayAgreeList.length != 0) {
            const res3 = await newContract.addPayAgree(this.form.contPayAgreeList)
            if (res3.code === 200) {
              await Toast.success('操作成功')
              setTimeout(() => {
                this.closeGo()
              }, 500)
            } else {
              Toast.fail(res3.msg)
            }
          } else {
            setTimeout(() => {
              this.closeGo()
            }, 500)
          }
          break
      }
    },
    async closeGo() {
      if (this.form.fileList.length == 0) {
        Toast.fail('请先上传附件')
        return
      }
      const returnCont = await newContract.getContract(this.form.contractId)
      if (this.form.custSource == 1 && (this.form.businessTypeName.indexOf('数字技术类') === -1 && this.form.businessTypeName.indexOf('品牌推广') === -1) && returnCont.data.contReturnPointList.length == 0) {
        Toast.fail('请先填写合同项目信息及项目返点')
        return
      }
      if (this.form.payType == 1 && this.form.templateType == 2) {
        Dialog.confirm({
        // title: '提示',
          message: '是否立即提交用章申请',
          confirmButtonText: '提交申请',
          confirmButtonColor: '#1989fa',
          cancelButtonText: '保存草稿'
        })
          .then(() => {
          // on confirm
            newContract.spApply({ contractId: this.form.contractId }).then((res) => {
              if (res.code === 200) {
                Toast.success('用章申请成功!')
                setTimeout(() => {
                  this.$router.go(-1)
                }, 500)
              } else {
                Toast.fail(res.msg)
              }
            })
          })
          .catch(() => {
          // on cancel
            this.$router.go(-1)
          })
      } else if (this.form.payType == 1 && this.form.templateType == 1) {
        Dialog.confirm({
        // title: '提示',
          message: '是否立即提交用印申请',
          confirmButtonText: '提交申请',
          confirmButtonColor: '#1989fa',
          cancelButtonText: '保存草稿'
        })
          .then(() => {
          // on confirm
            newContract.yyApply({ contractId: this.form.contractId }).then((res) => {
              if (res.code === 200) {
                Toast.success('用印申请成功!')
                setTimeout(() => {
                  this.$router.go(-1)
                }, 500)
              } else {
                Toast.fail(res.msg)
              }
            })
          })
          .catch(() => {
          // on cancel
            this.$router.go(-1)
          })
      } else if (this.form.payType == 2) {
        Dialog.confirm({
        // title: '提示',
          message: '是否立即提交垫款授信申请',
          confirmButtonText: '提交申请',
          confirmButtonColor: '#1989fa',
          cancelButtonText: '保存草稿'
        })
          .then(() => {
          // on confirm
            newContract.dkApply({ contractId: this.form.contractId }).then((res) => {
              if (res.code === 200) {
                Toast.success('垫款授信申请成功!')
                setTimeout(() => {
                  this.$router.go(-1)
                }, 500)
              } else {
                Toast.fail(res.msg)
              }
            })
          })
          .catch(() => {
          // on cancel
            this.$router.go(-1)
          })
      }
    },
    toStep(index) {
      // if (index == 4) {
      //   this.form.contPayAgreeList[0].companyName = this.form.companyName
      //   this.form.contPayAgreeList[0].companyId = this.form.companyId
      //   this.form.contPayAgreeList[0].custName = this.form.custName
      //   this.form.contPayAgreeList[0].custId = this.form.custId
      // }
      if (this.$route.query.contractId) {
        this.active = index
      } else {
        if (this.active == 0 || index == 0 || this.active == 1 || this.active == 2) {

        } else {
          this.active = index
        }
      }
    },
    async init() {
      // 修改主体框架标题
      document.title = '新建合同'
    },
    getFocus(index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
    },
    getSum(val) {
      if (this.index || this.index == 0) {
        if (val === 'advancesMoney' && this.form.contPayAgreeList[this.index][val].indexOf('.') != -1) {
          this.form.contPayAgreeList[this.index][val] = Number(this.form.contPayAgreeList[this.index][val]).toFixed(2)
        }
        if (val === 'amount' && this.form.fileList[this.index][val].indexOf('.') != -1) {
          this.form.fileList[this.index][val] = Number(this.form.fileList[this.index][val]).toFixed(2)
        }
        // if (this.form.fileList[this.index][val].indexOf('.') != -1) {
        //   this.form.fileList[this.index][val] = Number(this.form.fileList[this.index][val]).toFixed(2)
        // } else {
        //   this.form.contPayAgreeList[this.index][val] = Number(this.form.contPayAgreeList[this.index][val]).toFixed(2)
        // }
      } else {
        if (this.form[val].indexOf('.') != -1) {
          this.form[val] = Number(this.form[val]).toFixed(2)
        }
        this.amountWords = this.toChineseBig(this.form.contractMoney)
      }

      // let contractMoeny = this.form.contractMoney || 0;
      // let allReturnedMoney = this.form.allReturnedMoney || 0;
      // let total = contractMoeny - allReturnedMoney
      // this.form.noReturnedMoney = total.toFixed(2);
    },
    async showPicker(type, index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      this.picker.loading = true
      this.picker.columns = []
      this.picker.formKey = type
      const optionItem = type + 'Options'
      if (type === 'company') {
        // 获取公司信息
        // if (this.companyList.length == 0) {
        await listAddContract({ businessTypeId: this.form.businessTypeId }).then((response) => {
          this.companyList = response.rows
        })
        // }
        this.picker.columns = this.companyList.map((ele) => ele.companyName)
        this.picker.loading = false
      } else if (type === 'userName') {
        // 选择人员
        selectDeptIdByUserList(this.form.deptId).then(response => {
          this.deptUserList = response.data
          this.picker.columns = this.deptUserList.map(item => item.nickName)
          this.picker.loading = false
        })
      } else if (type === 'infoUserName') {
        selectDeptIdByUserList(this.form.infoDeptId).then(response => {
          this.deptUserList = response.data
          this.picker.columns = this.deptUserList.map(item => item.nickName)
          this.picker.loading = false
        })
      } else if (type === 'boId') {
        // 选择商机
        newContract.getBoListByUserId({ userId: this.form.userId }).then(response => {
          this.custBoList = response.rows
          this.picker.columns = this.custBoList.map(item => item.boName + '(' + item.custName + ')')
          this.picker.loading = false
        })
      } else if (type === 'bankAccount') {
        await payment.listPayBank({ companyId: this.form.companyId }).then(res => {
          if (res.code === 200) {
            this.payBankList = res.rows
          }
        })
        this.payBankList.forEach((ele) => {
          ele.incomeBankName = `${ele.bankName}(${ele.accountNum})`
        })
        this.picker.columns = this.payBankList.map((ele) => ele.incomeBankName)
        this.picker.loading = false
      } else {
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
        this.picker.loading = false
      }
      this.picker.visible = true
    },
    async pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      console.log('key:' + key)
      const name = this.picker.formKey + 'Name'
      if (this.index || this.index == 0) {
        if (this.picker.formKey === 'fileType') {
          this.form.fileList[this.index][this.picker.formKey] = this.options[optionItem][key].dictValue
          this.form.fileList[this.index][name] = this.options[optionItem][key].dictLabel
        } else {
          this.form.contPayAgreeList[this.index][this.picker.formKey] = this.options[optionItem][key].dictValue
          this.form.contPayAgreeList[this.index][name] = this.options[optionItem][key].dictLabel
        }
      } else {
        if (this.picker.formKey === 'company') {
          this.form.companyName = this.companyList[key].companyName
          this.form.companyId = this.companyList[key].companyId
          // if (this.form.businessTypeId) {
          //   this.getContCount()
          // }
          await payment.listPayBank({ companyId: this.form.companyId }).then(res => {
            if (res.code === 200 && res.rows.length > 0) {
              const ele = res.rows.find(res => { return res.isSelect == 1 })
              if (ele) {
                this.form.bankAccountId = ele.bankAccountId
                this.form.bankAccountName = `${ele.bankName}(${ele.accountNum})`
              }
            }
          })
        } else if (this.picker.formKey === 'boId') {
          this.form.boId = this.custBoList[key].boId
          this.form.boName = this.custBoList[key].boName
          this.form.custId = this.custBoList[key].custId
          this.form.custName = this.custBoList[key].custName
          this.form.contractName = this.custBoList[key].boName
          this.form.businessTypeName = this.custBoList[key].businessTypeName
          this.form.businessTypeId = this.custBoList[key].businessTypeId
          this.form.companyName = null
          this.form.companyId = null
          this.form.bankAccountName = null
          this.form.bankAccountId = null
          const name = this.form.businessTypeName.split('/')
          if (name[0] == '销售' && name[1] == '数字技术类') {
            this.isVendite = false
            this.form.frameType = '1'
            this.form.payType = '1'
            this.form.custSource = null
            this.form.payCycle = null
            // this.form.advancesCycle=null
            this.form.creditCycleType = null
            this.form.creditCycleValue = null
            this.form.collectionPeriod = null
            this.form.creditMoney = null
            this.form.mediaType = null
            this.form.cooperationPolicy = null
            this.form.operationMode = null
          } else {
            this.isVendite = true
            this.form.custSource = '1'
          }
          if (name[0] != '销售') {
            // this.isMarketing=true
          }
          // this.getContCount()
        } else if (this.picker.formKey === 'userName') {
          // this.form.nickName = this.deptUserList[key].nickName
          this.form.userName = this.deptUserList[key].nickName
          this.form.userId = this.deptUserList[key].userId
        } else if (this.picker.formKey === 'infoUserName') {
          // this.form.nickName = this.deptUserList[key].nickName
          this.form.infoUserName = this.deptUserList[key].nickName
          this.form.infoUserId = this.deptUserList[key].userId
        } else if (this.picker.formKey === 'bankAccount') {
          // this.form.incomeBankName = this.payBankList[key].incomeBankName
          // this.form.incomeBankId = this.payBankList[key].bankAccountId
          this.form.bankAccountId = this.payBankList[key].bankAccountId
          this.form.bankAccountName = `${this.payBankList[key].bankName}(${this.payBankList[key].accountNum})`
        } else {
          this.form[this.picker.formKey] = this.options[optionItem][key].dictValue
          this.form[name] = this.options[optionItem][key].dictLabel
        }
      }
      console.log(this.form)
      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    showCalendar(type, index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      this.datePicker.formKey = type
      if (type === 'filingDate') {
        this.datePicker.minDate = new Date(new Date().setDate(new Date().getDate() + 1))
        this.datePicker.maxDate = new Date(new Date().setDate(new Date().getDate() + 15))
      } else {
        this.datePicker.minDate = new Date(new Date().setDate(new Date().getDate() - 365))
        this.datePicker.maxDate = new Date(new Date().setDate(new Date().getDate() + 3650))
      }
      if (type === 'executionTime' || type === 'zxTime') {
        this.datePicker.type = 'range'
      } else {
        this.datePicker.type = 'single'
      }
      this.datePicker.showDate = true
    },
    dateConfirm(date) {
      // this.minDate = date
      if (this.index || this.index == 0) {
        if (this.datePicker.formKey === 'payTime') {
          this.form.contPayAgreeList[this.index][this.datePicker.formKey] = this.formatDate(date)
        } else if (this.datePicker.formKey === 'zxTime') {
          const [start, end] = date
          this.pointList[this.index].startTime = this.formatDate(start)
          this.pointList[this.index].endTime = this.formatDate(end)
          this.pointList[this.index].zxTime = `${this.formatDate(start)} 至 ${this.formatDate(end)}`
        }
      } else {
        if (this.datePicker.formKey === 'executionTime') {
          const [start, end] = date
          this.form.startTime = this.formatDate(start)
          this.form.endTime = this.formatDate(end)
          this.form.executionTime = `${this.formatDate(start)} 至 ${this.formatDate(end)}`
        } else {
          this.form[this.datePicker.formKey] = this.formatDate(date)
        }
      }
      this.datePicker.showDate = false
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },
    showTimePicker(type, index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      this.datetimePicker.formKey = type
      this.datetimePicker.showDate = true
    },
    datetimePickerConfirm(date) {
      if (this.index || this.index == 0) {
        this.pointList[this.index][this.datetimePicker.formKey] = this.formatDateTime(date)
      }
      this.datetimePicker.showDate = false
    },
    formatDateTime(date) {
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      var h = date.getHours()
      h = h < 10 ? ('0' + h) : h
      var minute = date.getMinutes()
      minute = minute < 10 ? ('0' + minute) : minute
      var second = date.getSeconds()
      second = second < 10 ? ('0' + second) : second
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
    },
    async showTreeSelect(item) {
      this.typeTree = item
      if (item == 'mediaLocation') {
        this.mediaSelect = true
        this.mediaActiveIds = []
        this.form.mediaLocationNames = ''
        this.form.mediaLocationName = ''
        // console.log(this.mediaActiveIds)
        if (this.options.mediaLocationOptions.length == 0) {
          await newContract.getTreeData({ deliveryLink: 2 }).then(res => {
            this.options.mediaLocationOptions = this.handleTree(res.rows, 'deliveryLinkId')
          })
        }
        this.treeItems = this.options.mediaLocationOptions.map(item => {
          return {
            id: item.deliveryLinkId,
            text: item.deliveryLinkName,
            children: item.children ? item.children.map(item => {
              return {
                id: item.deliveryLinkId,
                text: item.deliveryLinkName,
                disabled: false
              }
            }) : [],
            disabled: false
          }
        })
      } else if (item == 'deliveryLink') {
        this.deliverySelect = true
        this.deliveryActiveIds = []
        this.form.deliveryLinkNames = ''
        this.form.deliveryLinkName = ''
        if (this.options.deliveryLinkOptions.length == 0) {
          await newContract.getTreeData({ deliveryLink: 1 }).then(res => {
            this.options.deliveryLinkOptions = this.handleTree(res.rows, 'deliveryLinkId')
          })
        }
        this.treeItems = this.options.deliveryLinkOptions.map(item => {
          return {
            id: item.deliveryLinkId,
            text: item.deliveryLinkName,
            children: item.children ? item.children.map(item => {
              return {
                id: item.deliveryLinkId,
                text: item.deliveryLinkName,
                disabled: false
              }
            }) : [],
            disabled: false
          }
        })
      }
    },
    chooseTree(data) {
      if (this.typeTree == 'mediaLocation') {
        if (this.mediaActiveIds.length > 0) {
          this.treeItems.map((res, index) => {
            res.disabled = true
            if (this.treeActiveIndex == index) {
              this.treeItems[this.treeActiveIndex].disabled = false
            }
          })
        } else {
          this.treeItems.map((res) => {
            res.disabled = false
          })
        }
        const arr = []
        const arr2 = []
        this.treeItems[this.treeActiveIndex].children.map((res) => {
          if (this.mediaActiveIds.length > 0) {
            this.mediaActiveIds.map((item) => {
              if (res.id == item) {
                arr.push(this.treeItems[this.treeActiveIndex].text + '/' + res.text)
                arr2.push(res.text)
              }
            })
          }
        })
        this.form.mediaLocationIds = this.mediaActiveIds.join(',')
        this.form.mediaLocationNames = arr.join(',')
        this.form.mediaLocationName = arr2.join(',')
      } else if (this.typeTree == 'deliveryLink') {
        const arr = []
        const arr2 = []
        this.treeItems.map(res => {
          res.children.map(item => {
            if (this.deliveryActiveIds.length > 0) {
              this.deliveryActiveIds.map((item2) => {
                if (item.id == item2) {
                  arr.push(res.text + '/' + item.text)
                  arr2.push(item.text)
                }
              })
            }
          })
        })
        this.form.deliveryLinkIds = this.deliveryActiveIds.join(',')
        this.form.deliveryLinkNames = arr.join(',')
        this.form.deliveryLinkName = arr2.join(',')
      }
    },
    showCustList(index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      this.select_show = true
    },
    handleCancel() {
      this.select_show = false
    },
    selectBeforeClose(val) {
      this.form.contPayAgreeList[this.index].entrustCustId = val.custId
      this.form.contPayAgreeList[this.index].entrustCustName = val.custName
      this.select_show = false
    },
    getIndex(index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
    },
    // 返回布尔值
    beforeRead(file) {
      // console.log(file)
      const fileArr = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
      if (!fileArr.some((item) => { return file.type === item })) {
        Toast('请上传格式为 pdf/word 的文件')
        return false
      }
      return true
    },
    onOversize(file) {
      console.log(file)
      Toast('文件大小不能超过 10mb')
    },
    // handleContractRemove(file) {
    //   let picture = this.form.contractImg;
    //   if (picture.indexOf(file.url) == 0) {
    //     if (picture.indexOf(",") == -1) {
    //       picture = null;
    //     } else {
    //       picture = picture.replace(file.url + ",", "");
    //     }
    //   } else {
    //     picture = picture.replace("," + file.url, "");
    //   }
    //   this.form.contractImg = picture;
    //   this.pictureList = [];
    //   if (this.form.contractImg != null && this.form.contractImg.length > 0) {
    //     let payCaptures = this.form.contractImg.split(",");
    //     payCaptures.forEach((element) => {
    //       this.pictureList.push({
    //         url: element,
    //       });
    //     });
    //   }
    // },
    async uploadContractPictureFiles(file) {
      // this.form.fileName = file.file.name
      // if(this.index || this.index == 0){
      //   this.form.fileList[this.index].fileName = file.file.name
      // }
      const _file = file.file
      // 通过 FormData 对象上传文件
      var formData = new FormData()
      formData.append('file', _file)

      await newContract.uploadContractFile(formData)
        .then((res) => {
          // console.log("_RequestUploads_", res);
          if (res.code === 200) {
            // this.form.contractImg = res.url;
            // let picture = this.form.contractImg;
            // if (picture != null && picture.length > 0) {
            //   picture += "," + res.url;
            // } else {
            //   picture = res.url;
            // }
            // this.form.contractImg = picture;
            // let payCaptures = this.form.contractImg.split(",");
            // this.pictureList = [];
            // payCaptures.forEach((element) => {
            //   this.pictureList.push({
            //     url: element,
            //   });
            // });
            this.form.fileList[this.index].fileName = file.file.name
            this.form.fileList[this.index].url = res.url
            Toast.success(res.msg)
          } else {
            Toast.fail('res.msg')
          }
        })
        .catch(function (error) {
          console.error(error)
        })
    },
    viewFileTip() {
      this.showFileTip = true
    },

    // 获取项目名称列表
    getProjectList() {
      newContract.listProject({ bussType: 1, bussId: this.form.contractId }).then(res => {
        if (res.code == 200) {
          this.projectList = res.rows
        }
      })
    },
    // 新增项目名称
    addProject() {
      this.projectForm = { projectId: null, calculationMethod: 1 }
      if (this.projectList.length == 0) {
        this.isFirst = true
      } else {
        this.isFirst = false
      }
      this.selectProjectVisible = true
    },
    // 修改项目名称
    handleProjectUpdate(row, index) {
      if (index == 0) {
        this.isFirst = true
      } else {
        this.isFirst = false
      }
      this.projectForm = row
      this.selectProjectVisible = true
    },
    setProjectName(projectForm) {
      if (projectForm.projectName) {
        if (this.projectForm.projectId) {
          newContract.updateProject({ ...this.projectForm, ...projectForm }).then(res => {
            if (res.code == 200) {
              Toast.success('项目名称修改成功')
              this.getProjectList()
            } else {
              Toast.fail(res.msg)
            }
          })
        } else {
          newContract.addProject({ bussType: 1, bussId: this.form.contractId, ...projectForm }).then(res => {
            if (res.code == 200) {
              Toast.success('项目名称添加成功')
              this.getProjectList()
            } else {
              Toast.fail(res.msg)
            }
          })
        }
      }
      this.selectProjectVisible = false
      this.isFirst = false
    },
    // 删除项目名称
    handleProjectDelete(row) {
      const that = this
      Dialog.confirm({
        message: '是否确认删除项目名称为"' + row.projectName + '"的数据项?'
      })
        .then(() => {
          newContract.delProject(row.projectId).then(res => {
            if (res.code == 200) {
              that.getProjectList()
              Toast.success('删除成功')
            } else {
              Toast.fail(res.msg)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    // 操作项目名称返点
    handleProjectPoint(row) {
      this.projectForm = row
      this.setPointVisible = true
    },
    setProjectPoint(pointList) {
      // if(pointList && pointList.length > 0) {
      //   addRebate(pointList, this.formData.contractId).then(response => {
      //     if(response.code == 200) {
      //       this.msgSuccess("项目名称返点操作成功")
      //     }
      //   })
      // }
      this.getProjectList()
      this.setPointVisible = false
    },
    addPoint() {
      const peo = {
        contractId: this.form.contractId,
        projectName: null,
        percentage: '',
        useMoney: '',
        startTime: null,
        endTime: null
        // startTime: this.form.startTime,
        // endTime: this.form.endTime,
        // zxTime: this.form.executionTime
      }
      this.pointList.push(peo)
      const res = this.activeNamesP.some(item => {
        return this.pointList.length - 1 === item
      })
      if (res === false) {
        this.activeNamesP.push(this.pointList.length - 1)
      }
    },
    // deletePoint
    async deletePoint(item) {
      if (this.pointList[item].returnPointId) {
        const res = await newContract.deleteRebate(this.pointList[item].returnPointId)
        if (res.code === 200) {
          await Toast.success('删除成功')
        }
        await this.pointList.splice(item, 1)
      } else {
        await this.pointList.splice(item, 1)
      }
    },
    // selectProject(index) {
    //   this.projectIndex = index
    //   this.selectProjectVisible = true
    // },
    // setProjectName(projectName, index) {
    //   if (projectName) {
    //     this.pointList[index].projectName = projectName
    //   }
    //   this.selectProjectVisible = false
    // },
    addEnclosure() {
      const peo = {
        contractId: this.form.contractId,
        title: '',
        amount: '',
        fileType: '1',
        fileTypeName: '合同附件',
        fileDesc: '',
        url: ''
      }
      this.form.fileList.push(peo)
      const res = this.activeNamesC.some(item => {
        return this.form.fileList.length - 1 === item
      })
      if (res === false) {
        this.activeNamesC.push(this.form.fileList.length - 1)
      }
    },
    async deleteE(item) {
      if (this.form.fileList[item].id) {
        const res = await newContract.deleteContractFile(this.form.fileList[item].id)
        if (res.code === 200) {
          await Toast.success('删除成功')
        }
        await this.form.fileList.splice(item, 1)
      } else {
        await this.form.fileList.splice(item, 1)
      }
    },
    addPayment() {
      const peo = {
        contPayType: '',
        payTime: '',
        payCondition: '',
        contractMoney: '',
        contractId: this.form.contractId,
        companyName: this.form.companyName,
        companyId: this.form.companyId,
        custName: this.form.custName,
        custId: this.form.custId,
        entrustCustName: '',
        entrustCustId: ''
      }
      this.form.contPayAgreeList.push(peo)
      const res = this.activeNames.some(item => {
        return this.form.contPayAgreeList.length - 1 === item
      })
      if (res === false) {
        this.activeNames.push(this.form.contPayAgreeList.length - 1)
      }
    },
    async deleteT(item) {
      if (this.form.contPayAgreeList[item].payAgreeId) {
        const res = await newContract.deletePayAgree(this.form.contPayAgreeList[item].payAgreeId)
        if (res.code === 200) {
          await Toast.success('删除成功')
        }
        await this.form.contPayAgreeList.splice(item, 1)
      } else {
        await this.form.contPayAgreeList.splice(item, 1)
      }
      // const res = await newContract.deletePayAgree(this.form.contPayAgreeList[item].payAgreeId)
      // if (res.code === 200) {
      //   await Toast.success('删除成功')
      // }
      // await this.form.contPayAgreeList.splice(item, 1)
    },
    downloadUrlFile(url, fileName) {
      const url2 = url.replace(/\\/g, '/')
      const xhr = new XMLHttpRequest()
      xhr.open('GET', url2, true)
      xhr.responseType = 'blob'
      // xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
      // 为了避免大文件影响用户体验，建议加loading
      xhr.onload = () => {
        if (xhr.status === 200) {
          // 获取文件blob数据并保存
          this.saveAs(xhr.response, fileName)
        }
      }
      xhr.send()
    },
    addBo() {
      // this.$router.push({
      //   path: '/scrm/custBo/add'
      // })
      this.add_show = true
    },
    handleAddBoCancel() {
      this.add_show = false
    },
    // 添加合同
    async addBoBeforeClose(val) {
      if (!val) { this.handleAddBoCancel(); return }
      this.form.boId = val.boId
      this.form.boName = val.boName
      this.form.businessTypeName = val.businessTypeName
      this.form.custId = val.custId
      this.form.custName = val.custName
      this.form.contractName = val.boName
      this.form.businessTypeId = val.businessTypeId
      const name = this.form.businessTypeName.split('/')
      if (name[0] == '销售' && name[1] == '数字技术类') {
        this.isVendite = false
        this.form.frameType = '1'
        this.form.payType = '1'
        this.form.custSource = null
        this.form.payCycle = null
        // this.form.advancesCycle=null
        this.form.creditCycleType = null
        this.form.creditCycleValue = null
        this.form.collectionPeriod = null
        this.form.creditMoney = null
        this.form.mediaType = null
        this.form.cooperationPolicy = null
        this.form.operationMode = null
      } else {
        this.isVendite = true
        this.form.custSource = '1'
      }
      if (name[0] != '销售') {
        // this.isMarketing=true
      }
      // this.getContCount()
      this.add_show = false
      // await this.queryCustList()
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.pageBox{
  padding-bottom: 200px;
  .radioGroup{
    margin-top: 20px;
  }
  .bottomBtn{
    height: 130px;
    width: 100%;
    padding-top: 10px;
    background-color: #fff;
    position: fixed;
    bottom: calc(100px + env(safe-area-inset-bottom));
    .remark{
      text-align: center;
      font-size: 14px;
      color: #ee0a24;
    }
    .btnGroup{
      margin: 0;
      display: flex;
      align-items: center;
    }
  }
  .topBtn{
    margin: 0 auto;
    margin-bottom: 20px;
    width: 80%;
  }
}
.van-form {
  margin-bottom: 50px;
  .attachment_link{
    padding: 10px 20px 0 0;
    text-align: right;
  }
}
.van-cell__value {
  min-width: 71%; //可根据自己需求设定值
  text-align: left;
}
.dayuxiaoyufu{
  margin-left: 40px;
}
// /deep/ .van-field__label {
//   color: #333;
//   .ft(28);
// }
// // /deep/.van-field__control[disabled] {
// //   color: #000;
// //   opacity: 1;
// //   -webkit-text-fill-color: #000; // ios 和 安卓9.0 必须添加此属性，才会生效
// //   -webkit-opacity: 1;
// // }
// /deep/.van-field__control{
//   .ft(26);
//   color: #666666;
// }
// /deep/ .van-field__control::-webkit-input-placeholder {
//   // color: #666666;
//   .ft(26);
// }
.tagArr{
  padding: 0px 10px 10px 10px;
  /deep/.van-tag{
    margin-left: 10px;
  }
}
/deep/.van-sidebar-item--select::before{
  background-color: #1989fa;
}
/deep/.van-tree-select__item--active {
    color: #1989fa;
}
.notice_bar{
  height: 60px;
  font-size: 25px
}
.file_tip{
  padding: 5px 20px;
  min-height: 600px;
  font-size: 28px;
  line-height: 50px;
  div{
    font-weight: bold;
  }
}

.btns{
  display: flex;
  justify-content: center;
  .van-button {
    width: 20%;
    border-radius: 10px;
  }
}
</style>
